import { apiRequest } from '@/domains/api';
import type { IContentOverview } from './overview-contracts';

/** survey-api's website overview — `/api/v1/admin/website/overview` — and its sole reader. */
export const overviewApi = {
  read(signal?: AbortSignal): Promise<IContentOverview> {
    return apiRequest<IContentOverview>('/api/v1/admin/website/overview', { signal });
  }
};
